'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _HomeWhat = require('./HomeWhat.scss');

var _HomeWhat2 = _interopRequireDefault(_HomeWhat);

var _reactIntl = require('react-intl');

var _Modal = require('components/General/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  HomeWhat: {
    displayName: 'HomeWhat'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/HomeWhat.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var HomeWhat = _wrapComponent('HomeWhat')((_dec = (0, _reactCssModules2.default)(_HomeWhat2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(HomeWhat, _Component);

  function HomeWhat() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, HomeWhat);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HomeWhat.__proto__ || (0, _getPrototypeOf2.default)(HomeWhat)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: false
    }, _this.openMoal = function () {
      _this.setState({ isOpen: true });
    }, _this.closeModal = function () {
      _this.setState({ isOpen: false });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(HomeWhat, [{
    key: 'render',
    value: function render() {
      var localStoriesImage = require('./local-stories.png');
      var flexibleImage = require('./flexible-time.png');
      var hassleFreeImage = require('./hassle-free.png');
      return _react3.default.createElement(
        'div',
        { styleName: 'container' },
        _react3.default.createElement(
          'div',
          { styleName: 'inner' },
          _react3.default.createElement(
            'h2',
            { styleName: 'header' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_what.header' })
          ),
          _react3.default.createElement(
            'ul',
            { styleName: 'uvp' },
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement('img', { src: localStoriesImage, alt: 'Local story' }),
              _react3.default.createElement(
                'h3',
                { styleName: 'sub-header' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_what.local_stories.header' })
              ),
              _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_what.local_stories.description' }),
                ' ',
                _react3.default.createElement(
                  'a',
                  { styleName: 'link', onClick: this.openMoal },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_what.local_stories.link' })
                )
              ),
              this.state.isOpen ? _react3.default.createElement(
                _Modal2.default,
                { isOpen: this.state.isOpen, centerVertical: true, style: { 'maxWidth': '650px', 'borderRadius': '0', 'padding': '0', 'background': 'transparent' }, noClose: true, onClose: this.closeModal, id: 'home-video' },
                _react3.default.createElement('iframe', { src: 'https://player.vimeo.com/video/107616023?autoplay=1', width: '100%', height: '450', frameBorder: '0', allowFullScreen: true })
              ) : null
            ),
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement('img', { src: flexibleImage, alt: 'Flexible time' }),
              _react3.default.createElement(
                'h3',
                { styleName: 'sub-header' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_what.flexible.header' })
              ),
              _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_what.flexible.description' })
              )
            ),
            _react3.default.createElement(
              'li',
              null,
              _react3.default.createElement('img', { src: hassleFreeImage, alt: 'Hassle free' }),
              _react3.default.createElement(
                'h3',
                { styleName: 'sub-header' },
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_what.hassle_free.header' })
              ),
              _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'home.home_what.hassle_free.description' })
              )
            )
          )
        )
      );
    }
  }]);
  return HomeWhat;
}(_react2.Component)) || _class));

exports.default = HomeWhat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/HomeWhat.js
// module id = 1532
// module chunks = 47